import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {InsightsService} from "../../services/insights/insights.service";
import * as _ from 'lodash';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-performance',
  templateUrl: './performance.component.pug',
  styleUrls: ['./performance.component.scss'],
  standalone: false
})
export class PerformanceComponent implements OnInit, OnChanges {

  @Input() start!: any;
  @Input() end!: any;
  @Input() request!: any;
  @Input() questionnaire!: any;
  @Input() department!: any;
  @Input() filterBy!: any;
  @Input() selectedTab!: 'exits' | 'pulses';
  @Input() pulseDepartments:any;
  OrgPerformText = $localize`Organisational performance`

  perfMetrics: any[] = [];
  perfTrend = [];
  sectionLoading = true;

  constructor(private insightsService: InsightsService,
              private alertList: AlertBannerService
             ) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadAndSetData();
      if (this.pulseDepartments.length === 1) {
        this.OrgPerformText = $localize`Department performance: ${this.pulseDepartments[0].department}`
      }
      else {
        this.OrgPerformText = $localize`Organisational performance`
      }
  }

  private loadAndSetData() {
    if (this.selectedTab === 'pulses') {
      this.sectionLoading = true;
    }
    this.perfTrend = [];
    this.perfMetrics = [];

    if(this.selectedTab === 'exits') {
      this.insightsService.getPerfAll(this.start, this.end, this.questionnaire, this.filterBy).subscribe(data => {
        this.perfMetrics = Array.isArray(data['metrics']) ? data['metrics'] : [];
        this.perfTrend = data['trend'];
      }, error => {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      });
    } else {
      // Selected tab is Pulses
      forkJoin({
        trend: this.insightsService.getPulsePerfTrend(this.start, this.end, this.questionnaire, this.filterBy, this.department, this.request),
        metrics: this.insightsService.getPulseInsightsMetrics(this.start, this.end, this.request, this.department, this.questionnaire)
      }).subscribe((data: any) => {
        this.perfTrend = {
          ...data.trend,
          start: this.start,
          end: this.end
        };
        this.perfMetrics = Array.isArray(data.metrics?.pulse_metrics) ? data.metrics.pulse_metrics : [];
        if (data.metrics?.overall != null) {
          (this.perfMetrics as any).overall = data.metrics.overall;
        }
        this.sectionLoading = false;
      }, error => {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
        this.sectionLoading = false;
      });
    }
  }

}
